module.exports = __webpack_public_path__ + "img/store-2-red-used.9f000ffe.svg";